var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#26A17B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0811 9.77794V9.77682C10.0193 9.78132 9.70032 9.80044 8.98876 9.80044C8.42064 9.80044 8.0207 9.78357 7.88007 9.77682V9.77851C5.69307 9.68232 4.0607 9.30151 4.0607 8.84588C4.0607 8.39082 5.69307 8.01001 7.88007 7.91213V9.39938C8.02295 9.40951 8.43245 9.43369 8.99832 9.43369C9.67726 9.43369 10.0176 9.40557 10.0811 9.39994V7.91326C12.2636 8.01057 13.8921 8.39138 13.8921 8.84588C13.8921 9.30151 12.2636 9.68119 10.0811 9.77794ZM10.0811 7.75857V6.42769H13.1265V4.39819H4.8347V6.42769H7.88007V7.75801C5.40507 7.87163 3.54376 8.36213 3.54376 8.94938C3.54376 9.53663 5.40507 10.0266 7.88007 10.1408V14.4056H10.0811V10.1396C12.5522 10.026 14.409 9.53607 14.409 8.94938C14.409 8.36269 12.5522 7.87276 10.0811 7.75857Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32859"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/USDT.d92ae459f6e5cc1704fa371c7974e004.svg";
export { ForwardRef as ReactComponent };